import {Component, OnInit, ViewChild} from '@angular/core';
import {IOption} from "ng-select";
import {Location} from "@angular/common";
import {BsDatepickerConfig, BsModalRef} from "ngx-bootstrap";
import {BsModalService} from 'ngx-bootstrap/modal';
import {CorrectiveActionForwardAlmahComponent} from "../corrective-action-forward-almah/corrective-action-forward-almah.component";
import {HelperService} from "../services/helper.service";
import {LossPreventionAccessService} from "../services/loss-prevention-access.service";
import {RilrService} from "../services/rilr.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
    selector: 'app-corrective-action-almaha-history-modal',
    templateUrl: './corrective-action-almaha-history-modal.component.html',
    styleUrls: ['./corrective-action-almaha-history-modal.component.scss'],
    providers: [RilrService, HelperService, LossPreventionAccessService]
})
export class CorrectiveActionAlmahaHistoryModalComponent implements OnInit {

    public masterData: any = {};
    public employeeOption: Array<IOption> = [];
    public priorityArr: Array<IOption> = [];
    public departmentArr: Array<IOption> = [];
    public actionAreaSelectionArr: Array<IOption> = [];
    public confirmDisabled: number = 0;
    colorTheme = 'theme-blue';
    bsConfig: Partial<BsDatepickerConfig>;
    isEdit: number;
    actionID: number;
    correctiveActionCommentsArr: any = [];
    correctiveActionHistoryArr: any = [];
    inspectedByChecklist: string = '';
    profilePic: string = 'profileImage/default.png';
    commentActionButton: boolean = true;
    actionCompleteClose: boolean = false;
    disabledEnterAccess: boolean = true;
    disabled: boolean = false;
    allWaysDisabled: boolean = false;

    bsModalRefCorrectiveActionNewAl: BsModalRef;
    bsModalRefCAForwardAlMaha: BsModalRef;
    @ViewChild('errorMessageHtml') errorMessageHtml: any;
    @ViewChild('swalModalActionClose') swalModalActionClose: any;
    public htmlErrorMessage: string = "";

    nextActionComment: any = {
        correctiveActionID: this.actionID,
        comment: "",
    };

    companySystemID = +this.helperService.getSelectedCompanyId();
    currentUserSystemID = +this.helperService.getuserID();
    lptAccessDisable: boolean = false;

    yesNoArr: any = [
        {value: 0, label: 'Open'},
        {value: 1, label: 'In Progress'},
        {value: 2, label: 'Closed'}
    ];

  public repeatedArr: any = [
    {value: 0, label: 'New'},
    {value: 1, label: 'Repeated'},
  ];

    constructor(public bsModalRef: BsModalRef,
                private modalService: BsModalService,
                private rilrService: RilrService,
                private location: Location,
                private spinner: NgxSpinnerService,
                private lossPreventionAccessService: LossPreventionAccessService,
                private helperService: HelperService) {
        this.bsConfig = Object.assign({}, {containerClass: this.colorTheme, dateInputFormat: 'DD/MM/YYYY'});
    }

    ngOnInit() {
        this.masterData.personResEmpSystemID = [this.masterData.personResEmpSystemID];
        setTimeout(() => {
            this.getCorrectiveActionComments();
            this.getCorrectiveActionHistory();
            this.getEmployeeLptAccess();
            setTimeout(() => {
                this.getEmployeesEdit(this.masterData.personResEmpID);
                if (this.masterData.submitted === 2) {
                    this.confirmDisabled = 1;
                }
            }, 0);
            this.modalService.onHide.subscribe((reason: string, event) => {
                if (reason) {
                    if (reason === 'corrective_action_forward') {
                        this.getCorrectiveActionComments();
                        this.getCorrectiveActionHistory();
                        this.getActionForwardUser();
                    }
                }
            });
        }, 0);

    }

    closeModal() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason('corrective_action_edit_closed');
    }

    commentButtonAction() {
        this.commentActionButton = false;
    }

    cancelCorrectiveActionComment() {
        this.commentActionButton = true;
    }

    showErrorHtml() {
        setTimeout(() => {
            this.errorMessageHtml.show();
        }, 0);
    }

    getCorrectiveActionComments() {
        const that = this;
        that.spinner.show();
        that.correctiveActionCommentsArr = [];
        that.rilrService
            .getCorrectiveActionComments()
            .get({'actionID': that.actionID})
            .subscribe(resp => {
                that.correctiveActionCommentsArr = resp.data.data;
                that.spinner.hide();
            }, (error) => {
                that.spinner.hide();
            });
    }

    getCorrectiveActionHistory() {
        const that = this;
        that.correctiveActionHistoryArr = [];
        that.rilrService
            .getCorrectiveActionHistory()
            .get({'actionID': that.actionID})
            .subscribe(resp => {
                that.correctiveActionHistoryArr = resp.data.data;
            }, (error) => {

            });
    }

    addCorrectiveActionComment() {
        const that = this;
        if (that.nextActionComment.comment != '') {
            that.spinner.show();
            that.nextActionComment.correctiveActionID = that.actionID;
            that.nextActionComment.host = window.location.origin;
            that.rilrService
                .reportCorrectiveActionCommentsCRUD()
                .post(that.nextActionComment)
                .subscribe(resp => {
                    that.nextActionComment.comment = null;
                    that.cancelCorrectiveActionComment();
                    that.getCorrectiveActionComments();
                    that.getCorrectiveActionHistory();
                    that.spinner.hide();
                }, (error) => {
                    that.spinner.hide();
                });
        }

    }

    public typehead(value: any): void {
        let that = this;
        if (value.length > 2) {
            that.getEmployees(value);
        } else {
            that.employeeOption = [];
        }
    }

    getEmployees(value: any) {
        const that = this;
        that.rilrService
            .getTypeheadEmployees()
            .get({
                'search': value,
                'companySystemID': that.companySystemID
            })
            .subscribe(resp => {
                var tempOption = resp.data.data;
                that.employeeOption = [];
                that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, "employeeSystemID", "empName", "countryName", "description");
            }, (err) => {
                console.log(err);
                that.employeeOption = [];
            });
    }

    getEmployeesEdit(value: any) {
        const that = this;
        that.rilrService
            .getTypeheadEmployees()
            .get({
                'search': value,
                'companySystemID': that.companySystemID
            })
            .subscribe(resp => {
                var tempOption = resp.data.data;
                that.employeeOption = [];
                that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, "employeeSystemID", "empName", "countryName", "description");
                setTimeout(() => {
                    that.masterData.personResEmpSystemID = that.helperService.setSelectedValue(that.masterData.personResEmpSystemID);
                }, 0);

            }, (err) => {
                console.log(err);
                that.employeeOption = [];
            });
    }

    openCloseModal(field) {
        if (this.masterData.submitted && this.masterData.submitted === 2) {
            this.swalModalActionClose.show();
        } else {
            this.updateCorrectiveAction(field);
        }
    }

    cancelConfirmModel() {
        this.masterData.submitted = this.helperService.setSelectedValue(1);
    }

    updateCorrectiveAction(field) {
        const that = this;
        that.spinner.show();
        that.masterData.expectedCompletionDate = that.helperService.transformDate(that.masterData.expectedCompletionDate);
        that.masterData.host = window.location.origin;
        that.masterData.field = field;
        that.masterData.companySystemID = that.companySystemID;
        that.rilrService
            .reportCorrectiveActionAlMahaUD()
            .post(that.masterData)
            .subscribe(resp => {
                that.getCorrectiveActionHistory();
                that.spinner.hide();
            }, (error) => {
                that.htmlErrorMessage = "";
                that.htmlErrorMessage = error.data.message;
                that.showErrorHtml();
                that.masterData.submitted = this.helperService.setSelectedValue(1);
                that.spinner.hide();
            });

    }

    correctiveActionReAssign() {
        const that = this;
        that.bsModalRefCAForwardAlMaha = that.modalService.show(CorrectiveActionForwardAlmahComponent, {
            class: 'modal-md',
            backdrop: 'static'
        });
        that.bsModalRefCAForwardAlMaha.content.masterDataNew.actionAssignedTo = that.masterData.actionAssignedTo;
        that.bsModalRefCAForwardAlMaha.content.masterDataNew.actionID = that.masterData.actionID;
        that.bsModalRefCAForwardAlMaha.content.masterDataNew.personResEmpID = that.masterData.personResEmpID;
        that.bsModalRefCAForwardAlMaha.content.masterDataNew.personResEmpSystemID = that.masterData.personResEmpSystemID;
        that.bsModalRefCAForwardAlMaha.content.departmentArr = that.departmentArr;
        that.bsModalRefCAForwardAlMaha.content.masterDataNew.actionAssignedTo = that.helperService.setSelectedValue(that.masterData.actionAssignedTo);
        that.bsModalRefCAForwardAlMaha.content.masterDataNew.departmentID = that.helperService.setSelectedValue(that.masterData.departmentID);
        that.disabledEnterAccess = false;
    }

    getEmployeeLptAccess() {
        const that = this;
        that.lossPreventionAccessService
            .getCorrectiveActionLptAccess()
            .get({
                'actionID': that.actionID,
                'companySystemID': that.companySystemID
            })
            .subscribe(resp => {
                const temp = resp.data.data;
                if (temp.permission) {
                    that.lptAccessDisable = true;
                    that.disabled = false;
                } else {
                    that.disabled = true;
                }
            }, (err) => {
            });
    }

    getActionForwardUser() {
        const that = this;
        that.rilrService
            .getActionForwardUpdatedUser()
            .get({'actionID': that.actionID})
            .subscribe(resp => {
                const temp = resp.data.data;
                that.masterData.actionAssignedTo = temp.actionAssignedTo;
                that.masterData.personResEmpID = temp.personResEmpID;
                that.masterData.personResEmpSystemID = temp.personResEmpSystemID;
                this.masterData.personResEmpSystemID = [this.masterData.personResEmpSystemID];
                this.masterData.departmentID = [this.masterData.departmentID];
                that.masterData.departmentID = that.helperService.setSelectedValue(temp.departmentID);
                that.getEmployeesEdit(temp.personResEmpID);
            }, (error) => {

            });
    }
}



// WEBPACK FOOTER //
// /app/src/app/corrective-action-almaha-history-modal/corrective-action-almaha-history-modal.component.ts